import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'currencyToLocal',
  standalone: true
})
export class CurrencyToLocal implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  readonly transform = (amount: any, exchangeRate: any, currency?: any) => {
    if(exchangeRate && amount) {
      exchangeRate = Number(exchangeRate);
      amount = Number(amount);

      return this.currencyPipe.transform(amount * exchangeRate, currency);
    }
    return currency ? `${currency}0.00` : '$0.00';
  };
}
